import React from 'react';
import { Router } from '@/router/index';
import { useLocation, useNavigate } from 'react-router-dom';
import { decryptText, encryptText, isIOS, storage, initSecretKey, getSecretKey } from './utils';
import { useTranslation } from 'react-i18next'
import store from './store';
import { useSelector } from 'react-redux';
const qs = require('qs')

const App:React.FC = () => {

    const isMobile = navigator.userAgent.includes('AIA-Mobile')
    const { t } = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    // const [language, setLang] = React.useState<string>('en')
    const language = useSelector((state: any) => state.language)
    const [date, setDate] = React.useState(null)
	  let userType, userId
    
    

    const outsideUrl = [
      {
        path: '/eelogin',
        title: 'login.Login'
      },
      {
        path: '/mpf/ee/eelogon.jsp',
        title: 'login.Login'
      },
      {
        path: '/erlogin',
        title: 'login.Login'
      },
      {
        path: '/first-time-login',
        title: 'login.FirstTimeLogin'
      },
      {
        path: '/forgot-password',
        title: 'login.ForgetPassword'
      },
      {
        path: '/standard-report',
        title: userType === 'ee' ? 'standardReport.eeTitle' : 'standardReport.erTitle',
        titleEe: 'standardReport.eeTitle',
        titleEr: 'standardReport.erTitle'
      }
    ]

    React.useEffect(() => {
        if(!getSecretKey()){
          initSecretKey().then(()=>{
            setDate(new Date())
          })
        }
    }, [])

    React.useEffect(() => {
      	// 将手机端传过来的加数据 在这里进行加密
      	if (isIOS()) {
          console.log(' ========================================== 进App.tsx ==========================================')
          console.log(`App.tsx 将手机端传过来的加数据 在这里进行加密. userId的值：${storage.getItem('irpas_userId')}`)
          // if (storage.getItem('iMaiJ') === 'N') {
          console.log(storage.getItem('irpas_userId'))
          storage.getItem('irpas_userId') !== 'undefined' && encryptText('irpas_userId', JSON.parse(storage.getItem('irpas_userId')))
          storage.getItem('irpas_mfa_userId') !== 'undefined' && encryptText('irpas_mfa_userId', JSON.parse(storage.getItem('irpas_mfa_userId')))
          storage.getItem('anthnStatus') !== 'undefined' && encryptText('anthnStatus', JSON.parse(storage.getItem('anthnStatus')))
          storage.getItem('oktaBearerToken') !== 'undefined' && encryptText('oktaBearerToken', JSON.parse(storage.getItem('oktaBearerToken')))
          storage.getItem('accessToken') !== 'undefined' && encryptText('accessToken', JSON.parse(storage.getItem('accessToken')))
          storage.getItem('sessionToken') !== 'undefined' && encryptText('sessionToken', JSON.parse(storage.getItem('sessionToken')))
          storage.getItem('irpas_userType') !== 'undefined' && encryptText('irpas_userType', JSON.parse(storage.getItem('irpas_userType')))
          storage.getItem('irpas_corner') !== 'undefined' && encryptText('irpas_corner', JSON.parse(storage.getItem('irpas_corner')))
          storage.getItem('userName') !== 'undefined' && encryptText('userName', JSON.parse(storage.getItem('userName')))
          storage.getItem('showPerformance') !== 'undefined' && encryptText('showPerformance', JSON.parse(storage.getItem('showPerformance')))
          storage.getItem('loginInfo') !== 'undefined' && encryptText('loginInfo', JSON.parse(storage.getItem('loginInfo')))
          storage.getItem('showWarnBeforePasswordExpired') !== 'undefined' && encryptText('showWarnBeforePasswordExpired', JSON.parse(storage.getItem('showWarnBeforePasswordExpired')))
          storage.getItem('androidVersion', 'l') !== 'undefined' && encryptText('androidVersion', JSON.parse(storage.getItem('androidVersion')), 'l')
          storage.getItem('iosVersion', 'l') !== 'undefined' && encryptText('iosVersion', JSON.parse(storage.getItem('iosVersion', 'l')), 'l')
      	}
        userType = decryptText('irpas_userType')
        userId = decryptText('irpas_userId')
    }, [date])

    React.useEffect(() => {
      // alert(`App.tsx里获取到的语言：${language}`)
      // 先判断url里有没有lang 有的话存到本地
      const { href } = window.location
      const search = qs.parse(href.split('?')[1])
      // alert(`当前url: ${window.location.href}, search参数：${JSON.stringify(search)}`)
      const url = new URL(window.location.origin);
      url.pathname = window.location.pathname; 
      
      if(search.userType && window.location.pathname.includes('standard-report')){
        const urlUserType = search.userType
        if(urlUserType == 'ee' || urlUserType == 'er'){
          
          encryptText('irpas_userType', urlUserType)
        }
      }
        
        
      if (!search.lang) {
        // url 没有 lang
        const lang = JSON.parse(storage.getItem('irpas_language', 'l'))
        // alert(`url没有拼接language，从本地取然后拼接：${lang}`)

        if (lang) {
          store.dispatch({
            type: lang
          })
          url.searchParams.set('lang', lang);
          window.history.replaceState(null, '', url.toString())
        } else {
          // set default language: en
          storage.setItem('irpas_language', 'en', 'l')
          store.dispatch({
            type: 'en'
          })
          url.searchParams.set('lang', 'en');
          window.history.replaceState(null, '', url.toString())
        }
      } else {
        // alert(`url有拼接的language`)
        if (search.lang === 'en' || search.lang === 'b5') {
          storage.setItem('irpas_language', search.lang, 'l')
        } else {
          storage.setItem('irpas_language', 'en', 'l')
          url.searchParams.set('lang', 'en');
          window.history.replaceState(null, '', url.toString())
        }
        store.dispatch({
          type: JSON.parse(storage.getItem('irpas_language', 'l'))
        })
      }
    }, [date])

    React.useEffect(() => {
      console.log('route change!')
      const { href } = window.location
      const search = qs.parse(href.split('?')[1])
      const newUrlUserType = decryptText('irpas_userType')
      const url = new URL(window.location.origin);
      url.pathname = window.location.pathname; 
      url.searchParams.set('lang', JSON.parse(storage.getItem('irpas_language', 'l')));
      search.fileType && url.searchParams.set('fileType', search.fileType);
      search.from && url.searchParams.set('from', search.from);
      if(newUrlUserType && window.location.pathname.includes('standard-report')){
        url.searchParams.set('userType', newUrlUserType);
      }
      window.history.replaceState(null, '', url.toString())
    }, [location])

    if (!isMobile) {
      React.useEffect(() => {
        window.scrollTo(0, 0)

        const { pathname } = location
        // 添加title
        outsideUrl.forEach(item => {
          if (item.path === pathname) {
            // console.log('添加title...')
            document.title = t(item.title)
            if(pathname === '/standard-report'){
              document.title = t(decryptText('irpas_userType') === 'ee' ? 'standardReport.eeTitle' : 'standardReport.erTitle')
            }
          }

          // 如果已经登录成功要跳转到outsideUrl里的页面 要做拦截
          if (item.path === pathname && decryptText('irpas_userId')) {
            navigate('/homepage')
          }
        })
      }, [location, language])
    }

    // store.subscribe(() => {
    //   setLang(store.getState().language)
    // })

    return (
      // <BrowserRouter basename='/THAI'>
        <Router />
      // </BrowserRouter>
    );
}

export default App;
